export default __webpack_public_path__ + "static/media/video.3b83d274.svg";